import styled from 'styled-components';
import colors from '../../../config/colors';

const ModalContainer = styled.div`
  max-width: 944px;
  width: 100%;
  max-height: 100%;
  overflow-y: auto;
  background: ${colors.WHITE_COLOR};
  box-shadow: 0 0 20px ${colors.SHADOW_GRAYDARK};
  border-radius: 10px;
  margin: auto;
  flex-shrink: 0;
  position: relative;
  transition: top 300ms ease-out;
  top: -100px;

  .scrollbar {
    height: 100% !important;
    max-height: none !important;
  }

  .scrollbar-content {
    max-height: none !important;
  }
`;

export default ModalContainer;
